import styled from 'styled-components';

export const DropdownContentWrapper = styled.div`
    overflow: hidden;
    border-radius: 1rem;
    box-shadow: 0px 2px 10px 1px rgba(9, 9, 11, 0.15);
`;

export const DropdownContentScroller = styled.div`
    background: ${({ theme }) => theme.colors['neutral-0']};
    border-radius: 1rem;
    min-width: fit-content;
    overflow: auto;
    overflow-x: hidden;
    max-height: 12rem;

    button {
        border-bottom: 0.1px solid rgba(9, 9, 11, 0.15);
    }

    button:first-child {
        border-top-left-radius: 1rem;
        border-top-right-radius: 1rem;
    }

    button:last-child {
        border: none;
        border-bottom-left-radius: 1rem;
        border-bottom-right-radius: 1rem;
    }
`;

type DropdownWrapperProps = {
    longestValue: number;
};

export const DropdownWrapper = styled.button<DropdownWrapperProps>`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;

    border: 2px solid ${({ theme }) => theme.colors['neutral-300']};
    border-radius: 1.875rem;
    padding: 0.71875rem 0.75rem;
    gap: 0.5rem;

    background: none;
    cursor: pointer;

    font-size: 0.875rem;

    width: fit-content;
    min-width: ${({ longestValue }) => `${longestValue}ch`};

    &[aria-selected='true'] {
        width: 100%;
    }

    &.open {
        box-shadow: 0px 2px 10px 1px rgba(9, 9, 11, 0.15);
        /* border: 2px solid ${({ theme }) => theme.colors['neutral-500']}; */
    }
`;

export const DropdownElement = styled.button`
    display: flex;
    align-items: center;
    border: none;
    width: 100%;
    background: none;
    cursor: pointer;
    padding: 0.75rem;
    gap: 0.5rem;
    color: var(--Neutral-800, #27272a);
    font-size: 0.8rem;
    font-weight: 600;
    line-height: 1rem;
    transition: 0.1s;

    &:hover {
        background: ${({ theme }) => theme.colors['neutral-50']};
    }
`;
